type Props = {
  show?: boolean
}

const ScreenIndicator = ({ show = true }: Props) => {
  if (import.meta.env.VITE_NODE_ENV !== "development") return null

  if (!show) return null
  return (
    <div className="fixed inset-0 w-full h-full pointer-events-none z-50">
      <div className="w-full h-full border border-purple-500 sm:hidden flex justify-center items-end">
        <div className="text-white text-sm h-fit w-fit bg-purple-500 px-2 py-1 rounded-md">
          xs
        </div>
      </div>
      <div className="w-full h-full border border-blue-500 hidden sm:flex md:hidden justify-center items-end">
        <div className="text-white text-sm h-fit w-fit bg-blue-500 px-2 py-1 rounded-md">
          sm
        </div>
      </div>
      <div className="w-full h-full border border-yellow-500 hidden  md:flex lg:hidden justify-center items-end">
        <div className="text-white text-sm h-fit w-fit bg-yellow-500 px-2 py-1 rounded-md">
          md
        </div>
      </div>
      <div className="w-full h-full border border-green-500 hidden lg:flex xl:hidden justify-center items-end">
        <div className="text-white text-sm h-fit w-fit bg-green-500 px-2 py-1 rounded-md">
          lg
        </div>
      </div>
      <div className="w-full h-full border border-pink-500 hidden xl:flex 2xl:hidden justify-center items-end">
        <div className="text-white text-sm h-fit w-fit bg-pink-500 px-2 py-1 rounded-md">
          xl
        </div>
      </div>
      <div className="w-full h-full border border-violet-500 hidden 2xl:flex justify-center items-end">
        <div className="text-white text-sm h-fit w-fit bg-violet-500 px-2 py-1 rounded-md">
          2xl
        </div>
      </div>
    </div>
  )
}

export default ScreenIndicator
